module.exports = __webpack_public_path__ + "img/box2_tag2.3e1a9760.png";